import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

//Components...
import { LoginComponent } from './login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';

const routes: Routes = [
	{
		path: "",
		redirectTo:"login",
		pathMatch :"full",
		data: {
      layoutName: "layoutOne"
    }
	},
  {
    path: "login",
    component: LoginComponent,
    data: {
      layoutName: "layoutOne"
    }
	},
	{
    path: "reset-password",
    component: ResetPasswordComponent,
    data: {
      layoutName: "layoutOne"
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
